import { ElementRef } from '@angular/core';
import { CUSTOMIZE_PAGES_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { AccountsService } from 'apps/accounts/static/accounts/ts/services/accounts.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "apps/accounts/static/accounts/ts/services/accounts.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
const _c0 = a0 => ({ active: a0 });
function FundamentalsTabsComponent_ul_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul", 2)(1, "div", 3)(2, "a", 4);
    i0.ɵɵlistener("click", function FundamentalsTabsComponent_ul_1_Template_a_click_2_listener() { const periodicityOption_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updatePeriodicity(periodicityOption_r2)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const periodicityOption_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, periodicityOption_r2 === ctx_r2.periodicity));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(periodicityOption_r2);
} }
const SECTIONS = { 'Income Statement': 0, 'Balance Sheet': 1, 'Cash Flow': 2 };
const USER_PREFERENCE_NAME = 'stock_fundamentals_periodicities';
export class FundamentalsTabsComponent {
    constructor(eltRef, accountsService) {
        this.eltRef = eltRef;
        this.accountsService = accountsService;
        this.section = 'Income Statement';
        this.USER = window.USER;
        this.allPeriodicities = [];
        this.periodicityIndex = 0;
        this.periodicity = '';
        this.defaultPeriodicities = JSON.parse(this.eltRef.nativeElement.getAttribute('defaultPeriodicities'));
        this.periodicityOptions = JSON.parse(this.eltRef.nativeElement.getAttribute('periodicityOptions'));
        this.section = this.eltRef.nativeElement.getAttribute('section');
    }
    ngOnInit() {
        if (this.section === 'Income Statement') {
            this.periodicityIndex = 0;
        }
        else if (this.section === 'Balance Sheet') {
            this.periodicityIndex = 1;
        }
        else if (this.section === 'Cash Flow') {
            this.periodicityIndex = 2;
        }
        this.accountsService.getUserPreferences().subscribe({
            next: (preferences) => {
                this.allPeriodicities = preferences.stock_fundamentals_periodicities;
                this.periodicity = this.allPeriodicities[this.periodicityIndex];
            },
            error: () => {
                this.periodicity = this.defaultPeriodicities[this.periodicityIndex];
            },
        });
    }
    updatePeriodicity(periodicityOption) {
        if (periodicityOption !== this.periodicity) {
            if (this.USER.authenticated) {
                const newPeriodicities = [...this.allPeriodicities];
                newPeriodicities[this.periodicityIndex] = periodicityOption;
                this.accountsService.putUserPreferences({ [USER_PREFERENCE_NAME]: newPeriodicities }).subscribe(() => {
                    window.location.reload();
                });
            }
            else {
                this.featureNeededComponent.openModal(CUSTOMIZE_PAGES_FEATURE);
            }
        }
    }
}
FundamentalsTabsComponent.ɵfac = function FundamentalsTabsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundamentalsTabsComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.AccountsService)); };
FundamentalsTabsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundamentalsTabsComponent, selectors: [["ycn-fundamentals-tabs"]], viewQuery: function FundamentalsTabsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, inputs: { defaultPeriodicities: "defaultPeriodicities", periodicityOptions: "periodicityOptions", section: "section" }, standalone: false, decls: 3, vars: 1, consts: [[1, "panel-action"], ["class", "nav nav-tabs", 4, "ngFor", "ngForOf"], [1, "nav", "nav-tabs"], [1, "nav-item"], ["href", "javascript:void(0)", 1, "nav-link", 3, "click", "ngClass"]], template: function FundamentalsTabsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, FundamentalsTabsComponent_ul_1_Template, 4, 4, "ul", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.periodicityOptions);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i3.FeatureNeededComponent], encapsulation: 2 });
